export function isJwtExpired(token: string): boolean {
  try {
    const payloadBase64 = token.split(".")[1];
    if (!payloadBase64) return true;

    const normalized = payloadBase64.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(normalized));

    return !payload?.exp || Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
}

export function shouldInvalidateFromResponse(status?: number): boolean {
  return status === 401 || status === 403;
}